const searchPageConfig = {
  FILTER_DISPLAY_COUNT_DESKTOP: 5,
  FILTER_DISPLAY_COUNT_MOBILE: 10,
  INFINITE_LOADING_HEIGHT_RANGE_DESKTOP: 700,
  INFINITE_LOADING_HEIGHT_RANGE_MOBILE: 1200,
  BLOOMREACH_COOKIE: "_br_uid_2",
  FILTER_PRICE_CODE: "dyprice",
}

export default searchPageConfig
